import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {BillingModes} from '../models/BillingModes';
import * as B from '../models/BillingModes';
import {BillingMode} from 'ApplicationEntry/sagas/billingAgentSaga';

export enum BillingModesActionType {
  CHANGE_BILLING_MODES = 'billingmodes/CHANGE_BILLING_MODES',
}

export const getBillingModeList = (billingModeList: BillingMode[]) =>
  createAction(BillingModesActionType.CHANGE_BILLING_MODES, {billingModeList});

export type BillingModesAction = ReturnType<typeof getBillingModeList>;

export const isBillingModesAction = (action: any): action is BillingModesAction =>
  action.type in reverseEnum(BillingModesActionType);

type BillingModeState = BillingModes;

export default (state: BillingModeState, action: BillingModesAction) => {
  switch (action.type) {
    case BillingModesActionType.CHANGE_BILLING_MODES:
      return B.changeBillingModes(action.payload.billingModeList)(state);
    default:
      return state;
  }
};
